var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOkx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.403,
    height: 21.163,
    viewBox: "0 0 75.403 21.163",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-62.059 -90.446)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g886",
    transform: "translate(62.059 90.446)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path839",
    d: "M22.241,0H.63A.521.521,0,0,0,.274.138.455.455,0,0,0,.127.47V20.692a.456.456,0,0,0,.147.333.521.521,0,0,0,.355.138H22.241a.522.522,0,0,0,.356-.138.456.456,0,0,0,.147-.333V.47A.456.456,0,0,0,22.6.138.521.521,0,0,0,22.241,0ZM15.2,13.638a.455.455,0,0,1-.147.333.521.521,0,0,1-.355.138H8.168a.521.521,0,0,1-.355-.138.455.455,0,0,1-.147-.333V7.524a.455.455,0,0,1,.147-.333.521.521,0,0,1,.355-.138H14.7a.521.521,0,0,1,.355.138.455.455,0,0,1,.147.333Z",
    transform: "translate(-0.127)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path841",
    d: "M133.1,14.73h-6.534a.487.487,0,0,0-.5.47v6.114a.487.487,0,0,0,.5.47H133.1a.487.487,0,0,0,.5-.47V15.2A.487.487,0,0,0,133.1,14.73Z",
    transform: "translate(-65.746 -7.675)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path843",
    d: "M117.367,0h-6.534a.487.487,0,0,0-.5.47V6.585a.487.487,0,0,0,.5.47h6.534a.487.487,0,0,0,.5-.47V.471a.487.487,0,0,0-.5-.47Z",
    transform: "translate(-57.547 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path845",
    d: "M148.851,0h-6.534a.487.487,0,0,0-.5.47V6.585a.487.487,0,0,0,.5.47h6.534a.487.487,0,0,0,.5-.47V.471a.487.487,0,0,0-.5-.47Z",
    transform: "translate(-73.951 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path847",
    d: "M117.367,29.457h-6.534a.487.487,0,0,0-.5.47v6.114a.487.487,0,0,0,.5.47h6.534a.487.487,0,0,0,.5-.47V29.928A.487.487,0,0,0,117.367,29.457Z",
    transform: "translate(-57.547 -15.348)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path849",
    d: "M148.851,29.457h-6.534a.487.487,0,0,0-.5.47v6.114a.487.487,0,0,0,.5.47h6.534a.487.487,0,0,0,.5-.47V29.928A.487.487,0,0,0,148.851,29.457Z",
    transform: "translate(-73.951 -15.348)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path851",
    d: "M93.737,0H87.2a.487.487,0,0,0-.5.47V6.585a.487.487,0,0,0,.5.47h6.534a.487.487,0,0,0,.5-.47V.471a.487.487,0,0,0-.5-.47Z",
    transform: "translate(-45.235 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path853",
    d: "M93.737,29.457H87.2a.487.487,0,0,0-.5.47v6.114a.487.487,0,0,0,.5.47h6.534a.487.487,0,0,0,.5-.47V29.928A.487.487,0,0,0,93.737,29.457Z",
    transform: "translate(-45.235 -15.348)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path855",
    d: "M70.294,7.519a.456.456,0,0,0-.147-.333.52.52,0,0,0-.355-.138H62.755V.47a.456.456,0,0,0-.147-.333A.52.52,0,0,0,62.253,0H55.719a.521.521,0,0,0-.356.138.456.456,0,0,0-.147.333V20.682a.456.456,0,0,0,.147.333.521.521,0,0,0,.356.138h6.534a.52.52,0,0,0,.355-.138.456.456,0,0,0,.147-.333V14.1h7.036a.521.521,0,0,0,.355-.138.456.456,0,0,0,.147-.333Z",
    transform: "translate(-28.83)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkx);
export default __webpack_public_path__ + "static/media/okx.7a557c48e01c2aefbdb6f15e5f1b7296.svg";
export { ForwardRef as ReactComponent };